   export const OPERATION_MODES = {                                                    
     VORLESEN: "read_aloud",                                                           
     SAMMELN: "highlight",                                                             
     AUSLOSEN: "effects",                                                              
     GESTALTEN: "authoring",                                                           
     AUFNEHMEN: "record",                                                              
     ENTDECKEN: "word_clarification", // Note: This maps to highlight in current code  
     EDIT: "edit"                                                                      
   }; 